import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPowerTaxEquityPartnering } = loanFormModel.formField;

class IsTaxEquityPartnering implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isTaxEquityPartnering = isYes(
      application[systemPowerTaxEquityPartnering.name]
    );
    return isTaxEquityPartnering;
  }
}

export default new IsTaxEquityPartnering();
